import { defineRecipe } from '@chakra-ui/react'

export const inputAddonRecipe = defineRecipe({
  base: {
    flex: '0 0 auto',
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    alignSelf: 'stretch',
    borderRadius: 'l2',
  },
  variants: {
    variant: {
      outline: {
        borderWidth: '1px',
        border: '1px solid',
        borderColor: 'black',
        background: 'white',
        borderRadius: 'sm',
        color: 'brand.blue',
      },
      subtle: {
        borderWidth: '1px',
        borderColor: 'transparent',
        bg: 'bg.emphasized',
      },
      flushed: {
        borderBottom: '1px solid',
        borderColor: 'inherit',
        borderRadius: '0',
        px: '0',
        bg: 'transparent',
      },
    },
  },
  // variants: {
  //   variant: {
  //     outline: {
  //       border: '1px solid',
  //       borderColor: 'brand.blue',
  //       background: 'white',
  //       borderRadius: 'sm',
  //       color: 'gray.500',
  //     },
  //   },
  // },
})

// import { defineRecipe } from '@chakra-ui/react'
//
// export const inputAddonRecipe = defineRecipe({
//   base: {
//     flex: '0 0 auto',
//     width: 'auto',
//     display: 'flex',
//     alignItems: 'center',
//     whiteSpace: 'nowrap',
//     alignSelf: 'stretch',
//     borderRadius: 'l2',
//   },
//   variants: {
//     variant: {
//       outline: {
//         borderWidth: '1px',
//         borderColor: 'border',
//         bg: 'bg.muted',
//       },
//       subtle: {
//         borderWidth: '1px',
//         borderColor: 'transparent',
//         bg: 'bg.emphasized',
//       },
//       flushed: {
//         borderBottom: '1px solid',
//         borderColor: 'inherit',
//         borderRadius: '0',
//         px: '0',
//         bg: 'transparent',
//       },
//     },
//   },
//   defaultVariants: {
//     size: 'md',
//     variant: 'outline',
//   },
// })
